import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { ResponsiveContainer, Tooltip, LineChart, Line, CartesianGrid, XAxis, YAxis } from 'recharts'
import { Row, Col, Card, Spin, DatePicker } from 'antd'

import MenuGraph from './MenuGraph'

import { requestMessagesRange, requestUsersRange, requestConnectionsRange } from 'redux/Dashboard/actions'

// const { RangePicker } = DatePicker

class GraphStats extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            period: 'daily',
            ressource: 'users'
        }
    }
    componentDidMount() {
        const { requestMessagesRange, requestUsersRange, requestConnectionsRange } = this.props

        requestMessagesRange()
        requestUsersRange()
        requestConnectionsRange()
    }

    getData() {
        const { messagesRange, usersRange, connectionsRange } = this.props

        let ressource
        switch (this.state.ressource) {
            case 'connections':
                ressource = connectionsRange
                break
            case 'messages':
                ressource = messagesRange
                break
            default:
                ressource = usersRange
                break
        }

        let data = this.state.period === 'daily' ? ressource.day_values.slice(-7) : ressource.month_values
        return [...data].reverse()
        // return data
    }

    headerGraph() {
        return (
            <span style={{ textTransform: 'none', fontSize: 18 }}>
                Statistics
                <p style={{ fontSize: 12, color: 'grey' }}>
                    Statistics below are the highest numbers for the selected date. Date is based on the UTC time zone.
                </p>
            </span>
        )
    }

    onMenuChange(state) {
        this.setState(state)
    }

    render() {
        const { usersCounter, messagesCounter, connectionsCounter } = this.props
        const { loadingMessages, loadingUsers, loadingConnections } = this.props

        if (loadingMessages || loadingUsers || loadingConnections) {
            return (
                <Card title={this.headerGraph()} className="gx-card-metrics" bodyStyle={{ paddingTop: 8 }}>
                    <Spin />
                </Card>
            )
        } else {
            const data = this.getData()
            return (
                <Card title={this.headerGraph()} className="gx-card-metrics" bodyStyle={{ paddingTop: 8 }}>
                    {/* <RangePicker style={{ paddingBottom: 16 }} /> */}
                    <Row>
                        <Col lg={6} md={8} sm={24} style={{ paddingRight: 0 }}>
                            <MenuGraph
                                onChange={state => this.onMenuChange(state)}
                                state={this.state}
                                usersCounter={usersCounter}
                                messagesCounter={messagesCounter}
                                connectionsCounter={connectionsCounter}
                            />
                        </Col>
                        <Col lg={18} md={16} sm={24} style={{ paddingTop: 30 }}>
                            <ResponsiveContainer width="100%" height={300}>
                                <LineChart
                                    width={600}
                                    height={300}
                                    data={data}
                                    margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
                                >
                                    <CartesianGrid vertical={false} />

                                    <Line type="monotone" dataKey="number" stroke="#8884d8" animationDuration={500} />
                                    <Tooltip />
                                    <XAxis dataKey="period" tickLine={false} />
                                    <YAxis axisLine={false} tickLine={false} allowDecimals={false} />
                                </LineChart>
                            </ResponsiveContainer>
                        </Col>
                    </Row>
                </Card>
            )
        }
    }
}

const mapStateToProps = ({ dashboard }) => ({
    messagesCounter: dashboard.messagesCounter,
    connectionsCounter: dashboard.connectionsCounter,
    usersCounter: dashboard.usersCounter,

    messagesRange: dashboard.messagesRange,
    usersRange: dashboard.usersRange,
    connectionsRange: dashboard.connectionsRange,

    loadingMessages: dashboard.loadingMessagesRange || dashboard.loadingMessagesCounter,
    loadingConnections: dashboard.loadingConnectionsRange || dashboard.loadingConnectionsCounter,
    loadingUsers: dashboard.loadingUsersRange || dashboard.loadingUsersCounter
})

const mapActionsToProps = dispatch => ({
    requestMessagesRange: bindActionCreators(requestMessagesRange, dispatch),
    requestConnectionsRange: bindActionCreators(requestConnectionsRange, dispatch),
    requestUsersRange: bindActionCreators(requestUsersRange, dispatch)
})

export default connect(
    mapStateToProps,
    mapActionsToProps
)(GraphStats)
